"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var spx = function (value) {
    return "".concat(value, "spx");
};
exports.default = spx;
//# sourceMappingURL=spxResolver.js.map